import { render, staticRenderFns } from "./wageHistoryDetail.vue?vue&type=template&id=66b7d325&scoped=true&"
import script from "./wageHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./wageHistoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./wageHistoryDetail.vue?vue&type=style&index=0&id=66b7d325&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b7d325",
  null
  
)

export default component.exports